import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VehicleSearch from "@/pages/VehicleSearch";
import VehicleDetail from "@/pages/VehicleDetail";
import BookingSuccess from "@/pages/BookingSuccess";
import Dashboard from "@/pages/Dashboard";
import OwnerDashboard from "@/pages/OwnerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ProfileVerification from "@/pages/ProfileVerification";
import BookingDetail from "@/pages/BookingDetail";
import DriverDashboard from "@/pages/DriverDashboard";
import MobileTabBar from "@/components/MobileTabBar";
import InstallPrompt from "@/components/InstallPrompt";
import { HowItWorks, Trust, Host, Privacy } from "@/pages/StaticPages";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// ?embed=1 renders a page without site chrome (used inside the native app's WebViews)
const isEmbed = new URLSearchParams(window.location.search).get("embed") === "1";

function App() {
  return (
    <div className={`App min-h-screen bg-white ${isEmbed ? "" : "pb-16 md:pb-0"}`}>
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          {!isEmbed && <Navbar />}
          <main>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/vehicles" element={<VehicleSearch />} />
              <Route path="/vehicles/:id" element={<VehicleDetail />} />
              <Route path="/booking/success" element={<BookingSuccess />} />
              <Route path="/bookings/:id" element={<BookingDetail />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard/profile" element={<ProfileVerification />} />
              <Route path="/owner" element={<OwnerDashboard />} />
              <Route path="/driver" element={<DriverDashboard />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/trust" element={<Trust />} />
              <Route path="/host" element={<Host />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<Landing />} />
            </Routes>
          </main>
          {!isEmbed && <Footer />}
          {!isEmbed && <MobileTabBar />}
          {!isEmbed && <InstallPrompt />}
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
